// Core
import { Injectable } from '@angular/core';

// Raptor
import { RAPTOR_IS_NONE_DATA_KEY, RAPTOR_MULTI_CHOICE_NONE_VALUE } from '../constant/raptor-constants';

@Injectable()
export class RaptorMultichoiceService {
  private selectedValues: any;

  constructor() { }

  public setNoneData(question: any, formData: any): void {
    if (this.hasNone(question) && formData.data[`${question.key}_${RAPTOR_IS_NONE_DATA_KEY}`]) {
      question.data = [RAPTOR_MULTI_CHOICE_NONE_VALUE];
    }
  }

  public hasNone(question: any): boolean {
    if (question.settings && question.settings.choices) {
      return question.settings.choices.some((element: any) => element.is_none_option)
    }
    return false;
  }

  public createPayload(value: any): any[] {
    let multichoicePayload = [];
    for (let key in value) {
      if (value[key] === true && key !== RAPTOR_MULTI_CHOICE_NONE_VALUE) {
        multichoicePayload.push(key);
      }
    }
    return multichoicePayload;
  }

  public createNonePayload(question: any, formValues: any, payload: any): void {
    payload[`${question.key}_${RAPTOR_IS_NONE_DATA_KEY}`] = this.hasNoneSelected(formValues[question.key]);
  }

  public mapNoneValue(question: any) {
    if (question.settings && question.settings.choices) {
      question.settings.choices.forEach((choice: any) => {
        if (choice.is_none_option) {
          choice.value = RAPTOR_MULTI_CHOICE_NONE_VALUE;
        }
      });
    }
  }

  public setSelectedValues(values: any) {
    this.selectedValues = values;
  }

  public checkNone(newSelectedValues: any, questionControl: any): void {
    let currentSelectedValues = { ...newSelectedValues };
    const oldSelectedValues = this.selectedValues;

    if (oldSelectedValues) {
      const lastChangedKey = this.getChangedKey(oldSelectedValues, newSelectedValues);
      if (lastChangedKey && newSelectedValues[lastChangedKey]) {
        const selectedOptions = this.getSelectedOptions(newSelectedValues);

        // If the last changed option is None
        if (lastChangedKey === RAPTOR_MULTI_CHOICE_NONE_VALUE && selectedOptions && selectedOptions.length > 1) {
          this.resetExceptNone(currentSelectedValues, questionControl);
        }

        // Reset None if its selected earlier
        if (lastChangedKey !== RAPTOR_MULTI_CHOICE_NONE_VALUE && newSelectedValues[RAPTOR_MULTI_CHOICE_NONE_VALUE]) {
          this.resetNone(currentSelectedValues, questionControl);
        }
      }
    }
    this.setSelectedValues(currentSelectedValues);
  }

  private hasNoneSelected(value: any): boolean {
    return value[RAPTOR_MULTI_CHOICE_NONE_VALUE] && value[RAPTOR_MULTI_CHOICE_NONE_VALUE] === true ? true : false;
  }

  private getChangedKey(firstValues: any, secondValues: any): any {
    return Object.keys(secondValues).reduce((diff: any, key: string) => {
      return firstValues[key] === secondValues[key] ? diff : key;
    }, undefined)
  }

  private getSelectedOptions(values: any): any  {
    const keys = Object.keys(values);
    return keys.filter(key => values[key]);
  }

  private resetExceptNone(currentSelectedValues: any, questionControl: any): void {
    Object.keys(questionControl.controls).forEach(controlKey => {
      if (controlKey !== RAPTOR_MULTI_CHOICE_NONE_VALUE) {
        currentSelectedValues[controlKey] = false;
        questionControl.get(controlKey).patchValue(false, { emitEvent: false });
      }
    });
  }

  private resetNone(currentSelectedValues: any, questionControl: any): void {
    currentSelectedValues[RAPTOR_MULTI_CHOICE_NONE_VALUE] = false;
    questionControl.get(RAPTOR_MULTI_CHOICE_NONE_VALUE).patchValue(false, { emitEvent: false });
  }
}
